import { Page, SectionTitle } from '../components/imports'
import Logs from '../components/Logs'
import { LetsWork } from './Home'

const Log = () => {

  const s = {
    title: "LAWWD® LOG",
    descr: "A branding intelligence feed — logged daily."
  }

  return (
    <Page offset>
      <SectionTitle resp {...s} />
      <div className='resp my-20'>
        <Logs />
      </div>
      <LetsWork />
    </Page>
  )
}

export default Log